import React from 'react';
import { Link } from 'react-router-dom';

const Zakat: React.FC = () => {
  return (
    <div className="container mt-5">
      <h2>Zakat Information</h2>
      
      <div className="card mt-4">
        <div className="card-body">
          <h4>What is Zakat?</h4>
          <p>
            Zakat is one of the five pillars of Islam and an important obligation upon all Muslims who meet the criteria of Nisab. 
            It is not a light matter and a major sin if it is not paid.
          </p>
          
          <h4 className="mt-4">When is Zakat Owed?</h4>
          <p>
            When your total assets reach or go beyond Nisab on a given day, zakat is owed one lunar year from that day, 
            as long as your total assets do not go below zero and your total assets are still at or above Nisab one lunar year 
            from when you first reached Nisab.
          </p>
          
          <h4 className="mt-4">How Much is Zakat?</h4>
          <p>
            Zakat is 2.5% of your total qualifying assets (wealth that has been in your possession for one lunar year).
          </p>
          
          <div className="mt-4">
            <Link to="/zakat/calculator" className="btn btn-success me-2">
              Calculate Your Zakat
            </Link>
            <Link to="/nisab" className="btn btn-primary">
              Check Nisab Threshold
            </Link>
          </div>
        </div>
      </div>
      
      <div className="alert alert-warning mt-4">
        <strong>Important:</strong> Please make sure you have studied the Fiqh of Zakat. Without having studied Fiqh of Zakat, 
        you may make mistakes in calculating Zakat. Consult with a knowledgeable scholar if you have questions.
      </div>
    </div>
  );
};

export default Zakat;
